export const getIncomingAndPublishedData = (data) => {
  const finalData = data.filter(({ node }) => {
    if (node.field_affichage_planifie) {
      const date = new Date()

      const datePublication = node.field_date_de_publication
        ? new Date(node.field_date_de_publication)
        : null

      const dateDepublication = node.field_date_de_depublication
        ? new Date(node.field_date_de_depublication)
        : null

      if (datePublication && dateDepublication) {
        return datePublication <= date && date <= dateDepublication
      }

      if (datePublication && !dateDepublication) {
        return datePublication <= date
      }

      if (!datePublication && dateDepublication) {
        return date <= dateDepublication
      }
    }

    return true
  })
  return finalData
}
